import React from "react";
import Container from "./styled";
import ChangeCanales from "./changeCanales";
import { BsWhatsapp } from "react-icons/bs";
import { Fade } from "react-awesome-reveal";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import "tippy.js/animations/scale.css";
import "tippy.js/animations/scale-subtle.css";
import "tippy.js/animations/scale-extreme.css";

export default class Comunicacion extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      response: "",
      currentMode: "Atención",
    };
  }

  getCanales(currentMode) {
    const canales = {
      Atención: (
        <div className="dataContainer opacidad08">
          <p>
            Ante cualquier duda sobre tu seguro nos podés mandar un whatsapp al:
          </p>
          <Tippy content="De Lun. a Vie. de 9 a 18hs" animation="scale">
            <a
              id="wppButton"
              href="https://api.whatsapp.com/send?phone=541162097006&text=%C2%A1Hola%2C%20me%20gustar%C3%ADa%20obtener%20m%C3%A1s%20informaci%C3%B3n%20sobre%20el%20Seguro%20de%20Bici!%20"
              target="_blank"
            >
              <BsWhatsapp />
              <span>11 6209 7006</span>
            </a>
          </Tippy>
          <p>
            O Mandános un mail a:
            <a id="mailButton" href="mailto:emision@seguroweb.com.ar">
              emision@seguroweb.com.ar
            </a>
          </p>
        </div>
      ),
      Siniestros: (
        <div className="dataContainer opacidad08">
          <p>
            Ante cualquier duda sobre tu seguro nos podés mandar un whatsapp al:
          </p>
          <Tippy content="De Lun. a Vie. de 9 a 18hs" animation="scale">
            <a
              id="wppButton"
              href="https://api.whatsapp.com/send?phone=541128061469&text=%C2%A1Hola%2C%20me%20gustar%C3%ADa%20obtener%20m%C3%A1s%20informaci%C3%B3n%20sobre%20el%20Seguro%20de%20Bici!%20"
              target="_blank"
            >
              <BsWhatsapp />
              <span>11 2806 1469</span>
            </a>
          </Tippy>
          <p>
            O Mandános un mail a:
            <a id="mailButton" href="mailto:siniestros@seguroweb.com.ar">
              siniestros@seguroweb.com.ar
            </a>
          </p>
        </div>
      ),
      Cobranzas: (
        <div className="dataContainer opacidad08">
          <p>
            Ante cualquier duda sobre tu seguro nos podés mandar un whatsapp al:
          </p>
          <div id="wppButtonDiv">
            <BsWhatsapp id="logoDesktop" />
            <Tippy content="De Lun. a Vie. de 9 a 18hs" animation="scale">
              <a
                id="wppCanal3Frist"
                href="https://api.whatsapp.com/send?phone=541128061469&text=%C2%A1Hola%2C%20me%20gustar%C3%ADa%20obtener%20m%C3%A1s%20informaci%C3%B3n%20sobre%20el%20Seguro%20de%20Bici!%20"
                target="_blank"
              >
                <BsWhatsapp className="logoMobile" />
                11 2806 1469
              </a>
            </Tippy>
            <p className="barra">|</p>
            <Tippy content="De Lun. a Vie. de 9 a 18hs" animation="scale">
              <a
                href="https://api.whatsapp.com/send?phone=541128061540&text=%C2%A1Hola%2C%20me%20gustar%C3%ADa%20obtener%20m%C3%A1s%20informaci%C3%B3n%20sobre%20el%20Seguro%20de%20Bici!%20"
                target="_blank"
              >
                <BsWhatsapp className="logoMobile" />
                11 2806 1540
              </a>
            </Tippy>
            <p className="barra">|</p>
            <Tippy content="De Lun. a Vie. de 9 a 18hs" animation="scale">
              <a
                href="https://api.whatsapp.com/send?phone=541162096970&text=%C2%A1Hola%2C%20me%20gustar%C3%ADa%20obtener%20m%C3%A1s%20informaci%C3%B3n%20sobre%20el%20Seguro%20de%20Bici!%20"
                target="_blank"
              >
                <BsWhatsapp className="logoMobile" />
                11 6209 6970
              </a>
            </Tippy>
          </div>
          <p>
            O Mandános un mail a:
            <a id="mailButton" href="mailto:cobranzas@seguroweb.com.ar">
              cobranzas@seguroweb.com.ar
            </a>
          </p>
        </div>
      ),
    };
    return canales[currentMode];
  }

  toggleCanales = (currentMode) => {
    this.setState({ currentMode });
  };

  render() {
    return (
      <Container>
        <div className="canalesContainer">
          <Fade
            delay={100}
            duration={800}
            triggerOnce={true}
            className="titleContainer"
          >
            <h2>Nuestros Canales de Comunicación</h2>
          </Fade>
          <Fade delay={100} duration={800} triggerOnce={true}>
            <ChangeCanales toggleCanales={this.toggleCanales}></ChangeCanales>
          </Fade>
          {this.getCanales(this.state.currentMode)}
        </div>
      </Container>
    );
  }
}
